// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2Ex7w","info":"UpdateTermsInfo_info__2eIl4"};